<template>
    <div class="disposal">
        <cell
            title="协商结果"
            class="list"
        >
            <van-RadioGroup v-model="radio" class="radio">
                <van-Radio name="1">协商成功</van-Radio>
                <van-Radio name="2">协商失败</van-Radio>
            </van-RadioGroup>
        </cell>

        <cell  title="赔偿金额">
            <input type="text" placeholder="请输入赔偿金额" class="price">
        </cell>
        <van-field
            rows="2"
            autosize
            label="反馈内容"
            type="textarea"
            maxlength="50"
            required
            placeholder="请输入反馈内容"
            class="disText"
            label-width="auto"
        />
        <cell  title="附件上传" class="upload">
                <van-uploader :after-read="afterRead" />
        </cell>
        <div class="footer">
            <div>保存</div>
            <div>提交</div>
            <div>取消</div>
        </div>
        <textDialog></textDialog>
    </div>
</template>
<script>
    import textDialog from '../components/textDialog.vue'
    export default {
        components: {
            textDialog
        },
        data () {
            return {
                radio: '1'
            }
        },
        methods: {
            afterRead (file) {
                // 此时可以自行将文件上传至服务器
                console.log(file);
            }
        }
    }
</script>
<style lang="less" scoped>
.disposal {
    .list {
        .radio {
            display: flex;
        }
        .van-cell__value {
            padding-left: 20px;
        }
    }
    .price {
        padding-left: 20px;
    }
    // .disText .van-cell .van-cell--required .van-field {

    // }
    .van-cell__title, .van-cell__value {
        flex: none;
    }
    .upload .van-cell__value .van-uploader{
        position: static;
        padding-left: 20px;

    }
    .footer {
        width: 100%;
        height: 50px;
        background: #fff;
        position: fixed;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: space-around;
        div {
            background: #118BF5;
            color: #fff;
            font-size: 14px;
            height: 40px;
            width: 20%;
            border-radius: 5px;
            text-align: center;
            line-height: 40px;
        }
    }
}

</style>
<style>
.van-field__control {
    padding-left: 20px;
}
</style>
